<div class="d-flex flex-row align-items-center">
    <div 
        class="filter-name d-flex align-content-center" 
        (click)="onClickEvent()" 
        [ngClass]="{ 'active': isActive, 'inactive': !isActive }"
    >
        {{ filterDefinition.name }}
        <mat-icon>{{ dropDownIcon }}</mat-icon>
    </div>
</div>
<div class="filter-container" [style.display]="showFilterComponent ? 'block' : 'none'">
    <ng-template #filter></ng-template>
    <div class="filter-action-container">
        <button 
            *ngIf="!hideClearButton" 
            mat-raised-button
            class="filter-button filter-clear-button"
            (click)="onClearClick()"
        >
            Reset
        </button>
        <button mat-raised-button class="action-button" (click)="onApplyClick()">Apply</button>
    </div>
</div>